'use client';

export default function Error({ error }: { error: Error & { digest?: string } }) {
  return (
    <pre
      style={{
        background: '#0a0a0a',
        color: '#f87171',
        padding: '20px',
        fontSize: '11px',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        minHeight: '100vh',
      }}
    >
      {error?.name}: {error?.message}
      {'\n\n'}
      {error?.stack}
      {'\n\ndigest: '}
      {error?.digest}
    </pre>
  );
}
